// extracted by mini-css-extract-plugin
export default {"indicator":"styles_indicator__UuLDl"};